module.exports = __webpack_public_path__ + "ebf3717596cde32866f8444ef65d774e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1024.webp.png
// module id = 613
// module chunks = 0